import React from 'react';
import { motion } from 'framer-motion';

const Home = ({ onStart }) => {
  return (
    <div style={{ 
      backgroundColor: '#000D1A', 
      height: '100vh', 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center', 
      color: 'white',
      overflow: 'hidden',
      position: 'relative'
    }}>
      
      {/* 1. 배경 애니메이션: 움직이는 심연의 안개 */}
      <motion.div
        animate={{ 
          scale: [1, 1.2, 1],
          opacity: [0.3, 0.5, 0.3],
          rotate: [0, 10, 0]
        }}
        transition={{ duration: 10, repeat: Infinity, ease: "linear" }}
        style={{
          position: 'absolute',
          width: '150%',
          height: '150%',
          background: 'radial-gradient(circle, #1E3A8A 0%, transparent 70%)',
          filter: 'blur(80px)',
          zIndex: 0
        }}
      />

      {/* 2. 부유하는 파티클 (먼지 같은 효과) */}
      {[...Array(10)].map((_, i) => (
        <motion.div
          key={i}
          initial={{ y: Math.random() * 800, x: Math.random() * 400, opacity: 0 }}
          animate={{ y: [0, -100], opacity: [0, 0.5, 0] }}
          transition={{ duration: Math.random() * 5 + 5, repeat: Infinity, delay: i }}
          style={{
            position: 'absolute',
            width: '2px', height: '2px',
            backgroundColor: '#60A5FA',
            borderRadius: '50%',
            zIndex: 1
          }}
        />
      ))}

      {/* 3. 메인 콘텐츠 */}
      <div style={{ zIndex: 10, textAlign: 'center' }}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <p style={{ letterSpacing: '8px', color: '#60A5FA', fontSize: '14px', marginBottom: '20px' }}>
            PROJECT: INNER WILD
          </p>
          <h1 style={{ 
            fontSize: '3.5rem', 
            fontWeight: '900', 
            marginBottom: '10px',
            background: 'linear-gradient(to bottom, #FFFFFF, #94A3B8)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            lineHeight: '1.2'
          }}>
            심연의 본능
          </h1>
          <p style={{ color: '#64748B', fontSize: '1.1rem', marginBottom: '60px' }}>
            당신이 숨겨온 전설의 야수를 깨우십시오.
          </p>
        </motion.div>

        {/* 4. 에픽 시작 버튼 */}
        <motion.div
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          style={{ position: 'relative' }}
        >
          {/* 버튼 뒤 후광 효과 */}
          <motion.div
            animate={{ opacity: [0.4, 0.8, 0.4], scale: [1, 1.2, 1] }}
            transition={{ repeat: Infinity, duration: 2 }}
            style={{
              position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
              backgroundColor: '#3B82F6', filter: 'blur(25px)', borderRadius: '50px',
              zIndex: -1
            }}
          />
          
          <button
            onClick={onStart}
            style={{
              padding: '20px 60px',
              fontSize: '1.2rem',
              fontWeight: 'bold',
              color: 'white',
              background: 'rgba(255, 255, 255, 0.05)',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              borderRadius: '50px',
              cursor: 'pointer',
              backdropFilter: 'blur(10px)',
              letterSpacing: '2px'
            }}
          >
            탐험 시작하기
          </button>
        </motion.div>
      </div>

      {/* 5. 하단 장식 (나침반 좌표 느낌) */}
      <motion.div 
        initial={{ opacity: 0 }}
        animate={{ opacity: 0.3 }}
        transition={{ delay: 1.5 }}
        style={{ 
          position: 'absolute', bottom: '40px', fontSize: '10px', 
          letterSpacing: '4px', color: '#60A5FA' 
        }}
      >
        LAT: 37.5665° N / LONG: 126.9780° E
      </motion.div>
    </div>
  );
};

export default Home;